import { PropsWithChildren, useContext } from 'react';
import { useRouter } from 'next/router';
import IconHelp from '@/components/IconHelp';
import BalloonTalkBuyerSupport from '@/components/Modals/BalloonTalkBuyerSupport';
import { sideMenuAnimation } from '@/components/SideMenu';
import { useUser } from '@/contexts/AuthContext';
import { useDrawerContext } from '@/contexts/DrawerContext';
import { QuotationAnswerContext } from '@/contexts/QuotationAnswerContext';
import MainContainer from '@/layouts/MainContainer';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Typography } from '@mui/material';

interface IPageProps {
  title: string;
  onBack?: () => void;
  removeMarginTop?: boolean;
  removeIconBack?: boolean;
}

export const PageLayout = ({
  children,
  title,
  onBack,
  removeMarginTop,
  removeIconBack,
}: PropsWithChildren<IPageProps>) => {
  const router = useRouter();
  const { isDrawerOpen } = useDrawerContext();
  const { isAuthenticated } = useUser();
  const { quotationAnswer } = useContext(QuotationAnswerContext);

  const isQuotationAnswerWithIdParams =
    router.route === '/resposta-cotacoes/[id]';
  const isQuotationAnswerWithPaymentParams =
    router.route === '/resposta-cotacoes/[id]/pagamento';
  const isQuotationAnswerWithResumeParams =
    router.route === '/resposta-cotacoes/[id]/resumo';
  const isQuotationAnswer = router.route.includes('/resposta-cotacoes/[id]');

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: 'calc(100vh - 66px)',
        height: '100%',
      }}
    >
      <Box
        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.1)"
        position="relative"
        marginTop={removeMarginTop ? '' : '66px'}
        bgcolor="background.paper"
      >
        <MainContainer
          sx={{
            position: 'relative',
            padding: '18px 16px',
            textAlign: 'center',
          }}
        >
          {!removeIconBack && (
            <IconButton
              onClick={() => {
                onBack ? onBack() : router.back();
              }}
              sx={{
                position: 'absolute',
                left: '16px',
                top: '50%',
                transform: 'translateY(-50%)',
              }}
            >
              <ArrowBack
                sx={{
                  color: 'text.primary',
                }}
              />
            </IconButton>
          )}
          <Typography
            component="h3"
            variant="h6"
            sx={theme => ({
              ...sideMenuAnimation,
              textAlign: isQuotationAnswer ? 'start' : 'center',
              marginLeft:
                isQuotationAnswerWithPaymentParams && !isAuthenticated
                  ? '44px'
                  : isQuotationAnswerWithIdParams && !isAuthenticated
                  ? '28px'
                  : isQuotationAnswerWithResumeParams && !isAuthenticated
                  ? ''
                  : isQuotationAnswer
                  ? '48px'
                  : '',
              [theme.breakpoints.up('md')]: {
                paddingRight: isDrawerOpen ? 0 : isAuthenticated ? '56px' : 0,
                paddingLeft: 0,
              },
            })}
          >
            {title}
          </Typography>
          {isQuotationAnswer && (
            <Box
              sx={{
                position: 'absolute',
                right: '16px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
              }}
            >
              <BalloonTalkBuyerSupport
                nbUnreadMessages={quotationAnswer.nb_unread_customer_messages}
              />
              {!isAuthenticated && <IconHelp />}
            </Box>
          )}
        </MainContainer>
      </Box>
      {children}
    </Box>
  );
};
